module.exports = __webpack_public_path__ + "img/foot-btn-safe2.b45636c2.png";